import shoppingCart from '../assets/icons/shoppingCart.svg';
import medreleafCart from '../assets/icons/medreleafCart.svg';
import { useContext } from 'react';
import { CartContext } from '../context/cartContext';
import { UserContext } from '../context/userContext';

const ShoppingCart = () => {
  const { cart } = useContext(CartContext);
  const { loadingEnable } = useContext(UserContext);

  const cartCount = cart?.line_items?.length || 0;

  return (
    <a href={'/cart'} className="flex items-center relative">
      <img
        className={'w-8/12 mr-3'}
        id="cart"
        src={
          process.env.VITE_THEME_TOGGLE === 'MedReleaf'
            ? medreleafCart
            : shoppingCart
        }
        alt="shopping cart icon"
      />
      {!!cartCount && !loadingEnable && (
        <div
          className="bottom-auto left-auto right-1 top-1 absolute z-10 inline-block -translate-y-full -translate-x-0.5 rotate-0 
        skew-x-0 skew-y-0 scale-x-100 scale-y-100 rounded-full bg-primary-red-300 p-1.5 text-xs"
        ></div>
      )}
    </a>
  );
};

export default ShoppingCart;
